    
import React from "react";


function getMiddleElements(currentPage, totalPages, handlePageChange, visibleElementsOnBothSide){
  let startingPage = 2;
  let endingPage = visibleElementsOnBothSide * 2 + 2;
  if(currentPage > (visibleElementsOnBothSide + 1)){
    startingPage = (currentPage - visibleElementsOnBothSide) || currentPage;
    endingPage = ((currentPage + visibleElementsOnBothSide) < totalPages && (currentPage + visibleElementsOnBothSide)) || (totalPages - 1);
  }
  if((totalPages - currentPage)< (visibleElementsOnBothSide + 1)){
    startingPage = totalPages - (visibleElementsOnBothSide*2 + 1);
  }
  if(totalPages < visibleElementsOnBothSide * 2 + 3){
    startingPage = 2;
    endingPage = totalPages - 1;
  }
  let array = [...Array(endingPage - startingPage + 1)].map((_,i) => i + startingPage);
    return array.map(i => <li className={'page-item ' + (currentPage == i && ' active' || '')}><a href="javascript:void(0)" className="page-link" onClick={() => handlePageChange(i)} aria-label={"Page " + i + " of " + totalPages}>{i}</a></li>);
}

function Paginator(props) {
  return (
      <div>
        <nav aria-label="Page navigation">
          <ul className="pagination justify-content-center">
            <li className={'page-item ' + (props.currentPage == 1 && ' disabled' || '')}>
                      <a href="javascript:void(0)" className="page-link" onClick={() => props.handlePageChange(props.currentPage - 1)} aria-label={(props.currentPage > 1 ? 'Page ' + (props.currentPage - 1) + ' of ' + props.totalPages : '')}>Previous</a>
            </li>
                  <li className={'page-item ' + (props.currentPage == 1 && ' active' || '')}><a href="javascript:void(0)" className="page-link" onClick={() => props.handlePageChange(1)}
              aria-label=
                  { 'Page 1 of ' + props.totalPages } >1</a></li>
            {
              props.totalPages > props.visibleElementsOnBothSide*2 + 3
              && props.currentPage > props.visibleElementsOnBothSide*2
              && <li className="gap"><span>...</span></li>
            }
            {
                getMiddleElements(props.currentPage, props.totalPages, props.handlePageChange, props.visibleElementsOnBothSide)
            }
            {
              props.totalPages > props.visibleElementsOnBothSide*2 + 3
              && props.currentPage < props.totalPages - props.visibleElementsOnBothSide
              && <li className="gap"><span>...</span></li>
            }
            {
                      <li className={'page-item ' + (props.currentPage == props.totalPages && ' active' || '')}><a href="javascript:void(0)" className="page-link" onClick={() => props.handlePageChange(props.totalPages)} aria-label={'Page ' + props.totalPages + ' of ' + props.totalPages}>{props.totalPages}</a></li>
            }
            <li className={'page-item ' + (props.currentPage == props.totalPages && ' disabled' || '')}>
                      <a href="javascript:void(0)" className="page-link" onClick={() => props.handlePageChange(props.currentPage + 1)} aria-label={(props.currentPage != props.totalPages ? 'Page ' + (props.currentPage + 1) + ' of ' + props.totalPages : '')}>Next</a>
            </li>
          </ul>
        </nav>
      </div>
  );
}

export default Paginator;